<template>
  <div id="app">
    <!-- 路由占位符 -->
    <router-view v-wechat-title='$route.meta.title'></router-view>
    <!-- <div>
      <p>
        APP跟组件！
      </p>
    </div> -->
  </div>
</template>

<script>
// import markdownTest from './components/mdfiles/main.md'
export default {
  name: 'app',
  mounted () {
    if ((this.$route.path === '/main') || (this.$route.path === '/main_phone')) {
      // console.log(this.$route.path)
      // console.log(this.$router.resolve)
      if (this._isMobile()) {
        // console.log('This is phone page.')
        this.$router.replace('/main_phone')
      } else {
        // console.log('This is PC page.')
        this.$router.replace('/main')
      }
      // window.addEventListener('load', function () {
      //   // if (this.$route.path === '/date') { // /date 表示日期选择路由
      //   //   this.$router.replace('/list') // 列表页面的路由
      //   // }
      //   console.log('ttttt')
      //   console.log(this.$route.path)
      //   this.$router.replace('/main')
      // })
    }
  },
  methods: {
    _isMobile () {
      const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone|micromessenger|HarmonyOS)/i)
      return flag
    }
  }
  // components: {
  //   markdownTest
  // }
}
</script>

<style>
body {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}
/* 以下代码为网页转换为黑白色 */
/* html{
    filter: gray;
    filter: grayscale(100%);
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: url("data:image/svg+xml;utf8,<svg xmlns=\'http://www.w3.org/2000/svg\'><filter id=\'grayscale\'><feColorMatrix type=\'matrix\' values=\'0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0\'/></filter></svg>#grayscale");
    filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
    -webkit-filter: grayscale(1);
} */
</style>
